import {Fragment, React, _} from '@api';
import {useStores} from '@modules'
import {CustomAttributePdf, HexPdf, PdfProductCardRendererProps, SpecItemView, productCardStyles, SpecCardPdf, SpecItemPdf, PdfImagePlaceholder} from '@modules/pdf';
import {Image, Link, Page, StyleSheet, Text, View} from "@react-pdf/renderer";
import {nav} from '@stores'
import {styled} from '@pdf'

const RootView = styled.View`
  display:         flex;
  flex-direction:   column;
  background-color: white;
  font-family:      Helvetica;
  overflow:        hidden;
  flex-grow: 0;
  flex-shrink: 0;
  width: 4.35cm;
  padding:0.2mm;
`

const ImageContainer = styled.View`
  background-color: white;
  height:      5.75cm;
  width:4.35cm;
  margin: auto auto 0 auto;
  flex-grow:0;
  display:     flex;
  flex-direction: column;
`;

const ProductImage = styled.Image`
  flex-grow:      0;
  width:  100%;
  height:100%;   
  object-fit: contain;
  align-self: flex-end;
  margin-top: auto;    
`

const DetailsContainer = styled.View`
  display:        flex;
  flex-direction:  column;
  flex-grow:1;
  width: 4.35cm;
  border: 1px solid red;
  border-top-width: 1px;
  border-top-style: solid;
  border-top-color: black;
`

const ProductSpecsContainer = styled.View`
  display:        flex;
  flex-direction:  column;
`


const Title = styled.Text`
  font-size: 8pt;
  margin-bottom: 2mm;
`

const Subtitle = styled.Text`
  font-size: 8pt;
  margin-bottom: 2mm;
`

const Specs = styled.View<PdfProductCardRendererProps>`
  display:        flex;
  flex-direction:  column;
`

const Tags = styled.View`
  display:        flex;
  flex-direction:  column;
`

const ProductCardPdf = ({data, imageUrl, specs}: PdfProductCardRendererProps) => {
  const styles = StyleSheet.create({
    subtitle: {
      fontSize:     10,
      marginBottom: 10
    },

    emptyProductImage: {},

    productImage: {
      // flex:      0,
      // opacity:   1,
      // width:     '100%',
      // objectFit: 'contain',
      // alignSelf: 'flex-end',
      // marginTop: 'auto'
    },
  })

  const {
          vlp: {isVLPView}, catalog: {cv: {cardViewWithAttributes}}
        } = useStores()

  //console.log(data, specs)

  const isHex   = _.startsWith(imageUrl, '#')
  const isImage = !_.isEmpty(imageUrl) && !isHex

  const {title, tags, attributes} = data

  let visibleSpecs = specs.filter(spec => data[spec] && !data[spec].blank)

  return (
    <RootView>
      {/*<View style={styles.imageContainer}>*/}
      <ImageContainer>
        {isHex ? <HexPdf hex={imageUrl} style={{}}/> :
         isImage ? <ProductImage src={imageUrl} width={0} height={0}/> :
         <PdfImagePlaceholder />}
      </ImageContainer>

      <DetailsContainer>
        <Title>{data.title}</Title>

        <Specs key={'specs'} specs={specs}>
           {visibleSpecs.map((spec, i) =>
             <SpecItemPdf key={spec}
                          style={{ marginTop: i > 0 ? '2mm' : 0, marginLeft: 0}}
                          spec={data[spec]}
             />)}

          {isVLPView &&
          <Fragment>
            {cardViewWithAttributes.merch_product && data.merchProduct &&
            <SpecItemPdf spec={data.merchProduct}
                         style={{marginTop: '2mm', marginLeft: 0}}
                         hideImage />}

            {cardViewWithAttributes.merch_option_secondaries && !_.isEmpty(data.secondaries) &&
            <SpecItemPdf spec={{title: data.secondaries.map(s => s.name).join(', ')}}
                         style={{marginTop: '2mm', marginLeft: 0}}
                         hideImage/>}
          </Fragment>}
         </Specs>

         {isVLPView && !_.isEmpty(tags) && <Tags>
              {
                data.isAttributes &&
                (<Fragment>
                  <CustomAttributePdf 
                      key={'tags'} 
                      attributeLabel={'Tags(' + (data && data.tags && data.tags.length > 0 ? data.tags.length : 0) + ')'} 
                      attributeValue={data.tags && data.tags.length > 0 ? _.join(_.map(data.tags, 'name'), ', ') : '--'}/>
                </Fragment>)
              }
          </Tags>}

         {isVLPView && !_.isEmpty(attributes) && <Tags>
            {
              data.attributes && _.map(Object.keys(data.attributes), (attrName, i) => {
                let attrInfo = data.attributes[attrName]
                if (attrInfo && attrInfo.isVisible) {
                  return (
                    <CustomAttributePdf
                      key={`${attrName}-${attrInfo.id}-${i}`}
                      attributeLabel={attrInfo.displayName} 
                      attributeValue={attrInfo.value}
                    />
                  )
                }
                return null
              })
            }
          </Tags>}
      </DetailsContainer>
    </RootView>
  )
}

export default ProductCardPdf


// WEBPACK FOOTER //
// ./src/modules/pdf/templates/ProductCardPdf.tsx